import { render, staticRenderFns } from "./PortfolioListPage.vue?vue&type=template&id=3c734caa&"
import script from "./PortfolioListPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports